import { Entry, Query } from 'contentstack'

import { getCMSClient } from '../actions/get-cms-client'
import { EntryOption } from '../types'

import { getLocale } from './get-locale'
import { getQueryParams } from './get-query-params'

const fetchSingleEntry = (queryOrEntry: Query | Entry) =>
  queryOrEntry.entry_uid
    ? queryOrEntry.fetch()
    : (queryOrEntry as Query).findOne()

export async function fetchEntry<RawCMSEntry>({
  entryParams,
  query,
}: Required<EntryOption>): Promise<RawCMSEntry> {
  const CMSClient = getCMSClient()

  const contentTypeCMSQuery = CMSClient.ContentType(entryParams.contentTypeUid)
  let fetchEntryInstance: Entry | Query

  if ('entryUid' in entryParams) {
    fetchEntryInstance = contentTypeCMSQuery.Entry(entryParams.entryUid)
  } else {
    let queryInstance = getQueryParams(query).reduce(
      (CMSQuery, { key, value }) => CMSQuery.where(key, value),
      contentTypeCMSQuery.Query() as Query,
    )
    if ('entriesUid' in entryParams)
      queryInstance = queryInstance.where('uid', {
        $in: entryParams.entriesUid,
      })
    fetchEntryInstance = queryInstance
  }

  return (await fetchSingleEntry(
    fetchEntryInstance.language(getLocale()).includeFallback().toJSON(),
  )) as RawCMSEntry
}
